import React, { FunctionComponent } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { RootState } from "../../../store";

interface PrivateRouteProps {
  children: React.ReactNode;
  userRoles: string[];
  allowedRoles: string[];
}

const PrivateRoute: FunctionComponent<PrivateRouteProps> = ({ children, userRoles, allowedRoles }) => {
  const generalStore = useSelector((state: RootState) => state.general);

  const forceRedirect = !userRoles.some((userRole: string) =>
    allowedRoles.some((role: string) => role === userRole)
  );

  if (generalStore.unauthorized !== false) {
    return null;
  } else if (forceRedirect) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
